import TkInfoManual from "../../components/atoms/TkInfoManual";
import { infoHeadTitleList, stepperData } from "./parts";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { TkStepper } from "../../components/atoms/TkStepper";
import { Box } from "@mui/material";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkTable from "../../components/atoms/TkTable";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { funInfoBodyList } from "./hooks/useHooks";
import { httpAPI_FAC028 } from "./api/request";
import { toNumberOrUndefined } from "../../utils/useTools";

/**
 * SCRC050105コンポーネント。
 * このコンポーネントは、TkInfoManual,TkMessageDialogをレンダリングします。
 * @returns JSX.Element SCRC050105 施設等新設届の提出確認
 */
const SCRC050105 = () => {
  const navigate = useNavigate();

  //業務用Contextを更新するState
  const { state: businessState } = useContext(BusinessContext);
  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  //一時保存Stepperを更新するState
  const [checkAndSubmitstepper, setCheckAndSubmitStepper] = useState<number>();
  // ユーザタイプ
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  // テーブルデータの取得
  const [statusInfoTableList, setStatusInfoTableList] = useState<any>({
    infoHeadTitleList: infoHeadTitleList,
  });
  // 機構へ提出する/申請ボタンを押下時
  const [open, setOpen] = useState(false);

  useEffect(() => {
    //初期表示時に初期表示APIを呼び出し、取得結果とステッパーをState変数に設定する。
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //初期表示
  const handleInit = () => {
    let facilityList = businessState.job_15?.facilityList;
    let formList = businessState.job_15?.formList;
    if (facilityList && formList) {
      const infoBodyList = funInfoBodyList(facilityList, formList);
      let data = {
        infoHeadTitleList: infoHeadTitleList,
        infoBodyList: infoBodyList,
      };
      setStatusInfoTableList(data);
    }
    businessState?.job_15?.tempSaveStep &&
      setCheckAndSubmitStepper(
        toNumberOrUndefined(businessState?.job_15?.tempSaveStep)
      );
  };

  //施設等新設届一括更新API実行
  const handleOk = async (date?: any) => {
    try {
      const res = await httpAPI_FAC028({
        contractorNo: isKiko
          ? businessState.common?.contractorNo!
          : state.authInfo?.contractorNo!,
        applyId: businessState.job_15?.applyId!,
        receptionDate: date,
        screenId: "SCRC050105",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });

        setOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC050105PageForTest" className="SCRC050105">
      <TkStepper
        steps={stepperData}
        activeStep={1}
        savaStep={checkAndSubmitstepper}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050105_01}</TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}

      <TkTable
        headList={statusInfoTableList.infoHeadTitleList}
        bodyList={statusInfoTableList.infoBodyList}
      />
      <Box className="buttonGroup">
        <TkBackButton />
        <TkButton onClick={() => setOpen(true)}>
          {isKiko ? "申請" : "機構へ提出する"}
        </TkButton>
      </Box>

      {isKiko ? (
        <TkDateDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          title="確認（機構へ提出する）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC050105;
